import { WellframeApi } from 'store/api';
import { shortFormatDate } from 'utils';

export const checklistService = WellframeApi.injectEndpoints({
  endpoints: (builder) => ({
    getTasks: builder.query<RawTaskItem[], void>({
      query: () =>
        `/api/v2/tasks?task_date=${shortFormatDate('yyyy-mm-dd', new Date().toDateString())}`,
      providesTags: ['Task'],
    }),
    updateTask: builder.mutation<ChecklistTaskResponse, { body: UpdateTaskBody; taskId: number }>({
      query: ({ body, taskId }) => ({
        url: `/api/v2/tasks/${taskId.toString()}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (_result, error) => (error ? [] : ['Task', 'Stats']),
    }),
    completeTask: builder.mutation<ChecklistTaskResponse, { body: TaskBody; taskId: number }>({
      query: ({ body, taskId }) => {
        const transformedBody: CompleteTaskBody = {
          task: {
            ...body,
            completed_datetime: new Date().toISOString(),
            completed_datetime_time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          },
        };
        return {
          url: `/api/v2/tasks/${taskId.toString()}`,
          method: 'PATCH',
          body: transformedBody,
        };
      },
      invalidatesTags: (_result, error) => (error ? [] : ['Task', 'Stats']),
    }),
    updateStepGoal: builder.mutation<UpdateStepGoalResponse, string>({
      query: (goal) => ({
        url: '/api/v3/physical_activities/step_goals',
        method: 'POST',
        body: { create_step_goal: { target: goal } },
      }),
      invalidatesTags: (_result, error) => (error ? [] : ['Stats']),
    }),
  }),
});

export const {
  useGetTasksQuery,
  useUpdateTaskMutation,
  useCompleteTaskMutation,
  useUpdateStepGoalMutation,
} = checklistService;
